import { useState } from "react";
import Button from '../../../components/button/button';
import PasswordInput from '../../../components/passwordInput/passwordInput';
import { useSettings } from "../../../hooks/useSettings";

function Password() {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const { handlePasswordChange } = useSettings();

    const handleEdit = async () => {
        handlePasswordChange(currentPassword, newPassword, confirmNewPassword);
    }

    return (
        <div>
            <form className="settingsPasswordForm">
                <PasswordInput
                    labelFor='currentPassword'
                    labelValue='Dein altes Passwort: '
                    inputId='currentPassword'
                    inputValue={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    required
                    borderColor='black'
                    width="100%"
                />

                <PasswordInput
                    labelFor='newPassword'
                    labelValue='Dein neues Passwort: '
                    inputId='newPassword'
                    inputValue={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                    borderColor='black'
                    width="100%"
                />

                <PasswordInput
                    labelFor='confirmNewPassword'
                    labelValue='Bestätige dein neues Passwort: '
                    inputId='confirmNewPassword'
                    inputValue={confirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                    required
                    borderColor='black'
                    width="100%"
                />

                <Button buttonValue='Passwort ändern' onClick={handleEdit} />
            </form>
        </div>
    );
}

export default Password;